
import * as Yup from "yup";
import {t} from "i18next";

export type NewCommonForm = {
    companyId: number | null;
    auctionType: {value: string, label: string};
}

export const initialValues: NewCommonForm = {
    companyId: null,
    auctionType: {value: "", label: ""},

};

export function ValidationSchema() {
    return Yup.object({
        companyId: Yup.number()
            .required(t("validation.required")),
        auctionType: Yup.object({
            value: Yup.string().required(t("validation.required")),
        })
    })
}